import { faMailBulk } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Authentication from "@yodlee/common-components/dist/types/interfaces/authentication";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { CreateBulkSubscriptionContainer, CreateSubscriptionContainer } from "@yodlee/ycc-notification-widget/dist/containers";
import { Button, Drawer, Popover } from "antd";
import React, { useContext, useRef, useState } from "react";
import { ApplicationContext } from "../context";
import { Onload } from "../types/interfaces/onload";
import { getAuthenticationDetails } from "../utilities/authentication";

type ISubscriptionOptionsProps = {
    onSubscriptionView: () => void
    onload: Onload
    onAddSubscriber: () => void
}

const SubscriptionOptions: React.FC<ISubscriptionOptionsProps> = ({ onSubscriptionView, onload, onAddSubscriber }) => {
    const [addUserVisible, setAddUserVisible] = useState<boolean>(false);
    const [bulkUsersModalvisible, setBulkUsersModalVisible] = useState<boolean>(false);
    const [popupVisible, setPopupVisible] = useState<boolean>(false);
    const { selectedBrand } = useContext(ApplicationContext);
    const updateOnCloseBulkCreate: any = useRef();
    const authenticationDetails: Authentication = { ...getAuthenticationDetails(selectedBrand), metaData: { yc4ApiUrl: onload?.yc4ApiUrl } }

    const addUserModal =
        <Drawer
            width="85vw"
            placement="right"
            destroyOnClose={true}
            onClose={() => setAddUserVisible(false)}
            visible={addUserVisible}
            zIndex={addUserVisible ? 1001 : 1000}
        >
            <div className="margin-top-md">
                <CreateSubscriptionContainer
                    onCancel={() => setAddUserVisible(false)}
                    onCreate={(userResp) => {
                        let usersFailed = false, usersCreated = false;
                        (userResp || []).forEach((userRespItem) => {
                            if (userRespItem?.creationStatus === "SUCCESS") {
                                NotificationUtils.success("Success.", <div>
                                    <b>{userRespItem?.creationEnv}</b> subscriber creation successful.
                                </div>, "primary", undefined, undefined, 4);
                                usersCreated = true;
                            } else {
                                NotificationUtils.error("Error.", <div>
                                    <b>{userRespItem?.creationEnv}</b> subscriber creation failed.
                                    {userRespItem?.response?.data?.message}
                                </div>, "primary", undefined, undefined, 4);
                                usersFailed = true;
                            }
                        })

                        if (usersCreated)
                            onAddSubscriber();

                        if (!usersFailed)
                            setAddUserVisible(false);

                    }}
                    authentication={authenticationDetails}
                />
            </div>
        </Drawer>

    const bulkUploadModal = <CreateBulkSubscriptionContainer
        authentication={authenticationDetails}
        visible={bulkUsersModalvisible}
        onCancel={() => { setBulkUsersModalVisible(false); if (updateOnCloseBulkCreate.current) { updateOnCloseBulkCreate.current = false; onAddSubscriber(); } }}
        onCreate={(data) => {
            let allUsersSuccessful = true;
            (data?.data || []).forEach((result: any) => {
                if (result?.status !== "SUCCESS")
                    allUsersSuccessful = false;
            })
            if (allUsersSuccessful) {
                NotificationUtils.success("Success", "Subscribers created successfully.");
                setBulkUsersModalVisible(false);
                onAddSubscriber();
                if (updateOnCloseBulkCreate.current)
                    updateOnCloseBulkCreate.current = false;
            } else
                updateOnCloseBulkCreate.current = true;
        }}
    />

    return <>
        <Popover
            visible={popupVisible}
            onVisibleChange={(visible) => setPopupVisible(visible)}
            overlayClassName="alert-control-overlay"
            content={
                <>
                    <div className="padding-bottom-sm cursor-pointer" onClick={() => { setAddUserVisible(true); setPopupVisible(false); }}>
                        Add user
                    </div>
                    <div className="padding-bottom-sm cursor-pointer" onClick={() => { setBulkUsersModalVisible(true); setPopupVisible(false); }}>
                        Bulk upload user
                    </div>
                    <div className="cursor-pointer" onClick={() => { onSubscriptionView(); setPopupVisible(false); }}>
                        View subscriptions
                    </div>
                </>
            }
        >
            <Button type="default" >
                <FontAwesomeIcon className="margin-right-xs" icon={faMailBulk} />
                Subscriptions
            </Button>
        </Popover>
        {addUserModal}
        {bulkUploadModal}
    </>
}

export default SubscriptionOptions;
